<template>
  <v-container fluid>
    <div class="py-4 px-2 d-flex justify-space-between">
      <div class="d-flex align-center">
        <v-autocomplete
          v-model="selectedFeature"
          :items="companyFeatures"
          item-text="feature.title_th"
          item-value="feature.feature_uuid"
          flat
          solo
          dense
          hide-details
        ></v-autocomplete>
        <div class="ml-4" v-if="findFeature.employees">
          <span>
            (ฟรี
            {{
              findFeature.employees.length > findFeature.limit_free_employee
                ? findFeature.limit_free_employee
                : findFeature.employees.length
            }}/{{ findFeature.limit_free_employee }}, ทั้งหมด
            {{ findFeature.employees.length }}/{{
              findFeature.limit_max_employee === 0
                ? 'ไม่จำกัด'
                : findFeature.limit_max_employee
            }})
          </span>
        </div>
      </div>
      <div class="d-flex align-center">
        <v-text-field
          v-model="search"
          label="ค้นหา"
          prepend-inner-icon="mdi-magnify"
          clearable
          flat
          solo
          dense
          hide-details
        ></v-text-field>
        <v-btn @click="addCompanyFeature" color="primary" class="ml-4">
          <v-icon small left>mdi-plus</v-icon>เพิ่มพนักงาน
        </v-btn>
      </div>
    </div>

    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="findFeature.employees"
      :custom-filter="filterSearch"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.employee.firstname_th="{ item }">
        {{ `${item.employee.firstname_th} ${item.employee.lastname_th}` }}
      </template>
    </v-data-table>

    <CompanyFeatureForm
      :companyFeatureEmployee="companyFeatureEmployee"
      :companyFeatureEmployeeInit="companyFeatureEmployeeInit"
      :companyFeature="companyFeature"
      :formShow="formShow"
      :formAction="formAction"
      @isCompanyFeatureEmployeeDataChange="
        (value) => (isCompanyFeatureEmployeeDataChange = value)
      "
      @formActionCompleted="handleFormActionCompleted"
      @onReset="handleFormReset"
      @selectedEmployee="(value) => (companyFeatureEmployee.employee = value)"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="confirmDialogDataChange = false"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="formShow && formAction === 'add'"
      z-index="0"
    ></v-overlay>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'
import CompanyFeatureForm from '@/views/feature/CompanyFeatureForm.vue'

export default {
  name: 'CompanyFeature',

  components: {
    CompanyFeatureForm,
    ConfirmDialog,
  },

  data() {
    return {
      loading: true,
      search: '',
      sortBy: ['employee.firstname_th'],
      sortDesc: [false],
      headers: [
        {
          text: 'ชื่อพนักงาน',
          align: 'start',
          value: 'employee.firstname_th',
        },
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          value: 'employee.employee_code',
        },
        {
          text: 'หน่วยงาน',
          align: 'start',
          value: 'employee.organization.title_th',
        },
      ],
      selectedFeature: null,
      companyFeatureEmployee: { employee: {} },
      companyFeatureEmployeeInit: { employee: {} },
      companyFeature: {},
      formShow: false,
      formAction: '',
      isCompanyFeatureEmployeeDataChange: false,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      timeout: null,
    }
  },

  computed: {
    findFeature() {
      if (!this.selectedFeature) return {}
      return this.filterFeatures.find(
        (element) => element.feature.feature_uuid === this.selectedFeature
      )
    },
    filterFeatures() {
      return this.companyFeatures.map((company) => ({
        ...company,
        employees: this.employeeFeatures.filter(
          (employee) =>
            employee.feature.feature_uuid === company.feature.feature_uuid
        ),
      }))
    },
    companyFeatures() {
      return this.$store.state.feature.companyFeatures
    },
    employeeFeatures() {
      return this.$store.state.feature.employeeFeatures
    },
  },

  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ฟีเจอร์ (แยกตามฟีเจอร์)',
        disabled: true,
      },
    ])

    this.loadData()
  },

  methods: {
    ...mapActions({
      fetchEmployees: 'employee/fetchEmployees',
      fetchCompanyFeatures: 'feature/fetchCompanyFeatures',
      fetchEmployeeFeatures: 'feature/fetchEmployeeFeatures',
    }),
    classRowSelected(row) {
      if (
        this.companyFeatureEmployee.employee &&
        this.companyFeatureEmployee.employee.employee_uuid ===
          row.employee.employee_uuid
      )
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (
        this.companyFeatureEmployee.employee &&
        this.companyFeatureEmployee.employee.employee_uuid ===
          row.employee.employee_uuid
      ) {
        this.companyFeatureEmployee = { employee: {} }
        this.companyFeatureEmployeeInit = { employee: {} }
        this.companyFeature = {}
        this.formShow = false
        this.formAction = ''
      } else {
        this.companyFeatureEmployee = { ...row }
        this.companyFeatureEmployeeInit = { ...row }
        this.companyFeature = { ...this.findFeature }
        this.formShow = true
        this.formAction = 'edit'
      }
    },
    handleRowSelected(row) {
      if (this.isCompanyFeatureEmployeeDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleFormActionCompleted() {
      this.companyFeatureEmployee = { employee: {} }
      this.companyFeatureEmployeeInit = { employee: {} }
      this.companyFeature = {}
      this.formShow = false
      this.formAction = ''
    },
    handleFormReset(formAction) {
      if (formAction === 'add') {
        this.companyFeatureEmployee = { employee: {} }
        this.companyFeatureEmployeeInit = { employee: {} }
        this.companyFeature = {}
        this.formShow = false
        this.formAction = ''
        return
      }
    },
    addCompanyFeature() {
      this.companyFeature = { ...this.findFeature }
      this.formShow = true
      this.formAction = 'add'
    },
    filterSearch(value, search, item) {
      return (
        item.employee.firstname_th
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        item.employee.lastname_th
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        item.employee.employee_code
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        item.employee.organization.title_th
          .toLowerCase()
          .includes(search.toLowerCase())
      )
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      Promise.all([
        this.fetchEmployees({
          company_uuid,
          params: {
            is_active: true,
          },
        }),
        this.fetchCompanyFeatures({
          company_uuid,
          is_active: true,
        }),
        this.fetchEmployeeFeatures(company_uuid),
      ])
        .then(() => {
          this.loading = false

          const feature_uuid = this.companyFeatures[0].feature.feature_uuid
          this.selectedFeature = feature_uuid
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.formShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },

  beforeDestroy() {
    clearTimeout(this.timeout)
  },

  beforeRouteLeave(to, from, next) {
    if (this.isCompanyFeatureEmployeeDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
}
</script>
